import React, { useState, useEffect } from 'react';
import './SearchInput.css';

export const SearchInput = ({ defaultValue, onChange, onKeyDown }) => {
  const [value, setValue] = useState(defaultValue || '');

  useEffect(() => {
    onChange(value)
  }, [value]);

  const handleClear = () => {
    setValue('');
  };

  const handleChange = (e) => {

  }


  return (
    <div className="searchContainer">
      <input
        type="text"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={onKeyDown}
        placeholder="Search"
        className="searchInput"
      />
      <button
        className="iconButton"
        onClick={handleClear}
        aria-label={value ? 'Clear search' : 'Search'}
      >
        {value ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="icon"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="icon"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="11" cy="11" r="8" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
          </svg>
        )}
      </button>
    </div>
  );
};

export default SearchInput;
